var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100px",
    height: "100px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "download-alt-2",
    className: "icon glyph",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.82,17.43a1,1,0,0,0-1.41,0L13,18.84V12a1,1,0,0,0-2,0v6.7L9.59,17.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l3.18,3.18a1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,15.82,17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12a5,5,0,0,1-5,5h-.24a1.49,1.49,0,0,0-.23-.27A2,2,0,0,0,14,16.48V12a2,2,0,0,0-4,0v4.34a2,2,0,0,0-2.53.25.39.39,0,0,0-.08.1A7.5,7.5,0,1,1,16.58,7c.14,0,.28,0,.42,0A5,5,0,0,1,22,12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dc62de1bf9cd79a062516e5a4b806399.svg";
export { ForwardRef as ReactComponent };